import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//this component is used to print the page.
    let Record = useContext(RecordsManagementContext)
    let ClientPortalHeader = Record.CP_PageDetails.ClientPortalHeader

    const printInvoice1 =  async () => { // Function to print Invoice1 in Pdf Format & DownLoad it.
        let Url =`${ClientPortalHeader.PrintPortal.url}/print_invoice_2?id=${ClientPortalHeader.PrintPortal.estimate_id}`
        window.open(Url)
    }
    return (
        <button className='btn btn-dark btn-sm'
                onClick={()=> printInvoice1()}  ><b>PRINT INVOICE</b></button>
    )
}